"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RankedQuestionModule = void 0;
const base_1 = require("./base");
const util_1 = require("./util");
class RankedQuestionModule extends base_1.InputModule {
    constructor({ displayOrder = "desc", rankLow, rankHigh, rankRange, ...rest }) {
        super(rest);
        this._type = "RankedQuestion";
        if (rankRange !== 5 && rankRange !== 10) {
            throw new Error("ranked questions rankRange accepts values of 5 or 10");
        }
        this.displayOrder = displayOrder;
        this.rankLow = rankLow;
        this.rankHigh = rankHigh;
        this._rankRange = rankRange;
    }
    get rankRange() {
        return this._rankRange;
    }
    set rankRange(rankRange) {
        if (rankRange !== 5 && rankRange !== 10) {
            throw new Error("ranked questions rankRange accepts values of 5 or 10");
        }
        this._rankRange = rankRange;
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            const builderConfigModule = {
                actionRequired: this.actionRequired,
                id: this.id,
                noBorder: this.noBorder,
                rankLow: this.rankLow,
                rankHigh: this.rankHigh,
                rankRange: this.rankRange,
                label: this.label,
                required: this.required,
                style: this.style,
                type: this.type,
            };
            if (this.tag) {
                builderConfigModule.tag = this.tag;
            }
            if (this.hidden) {
                builderConfigModule.hidden = true;
            }
            return builderConfigModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        var _a;
        if (this.validate()) {
            const { required, label, rankLow, rankHigh, ...base } = this.toBuilderConfig();
            const surveyConfigModule = {
                ...base,
                actionRequired: this.actionRequired,
                header: { children: (_a = label[this.languageCode]) !== null && _a !== void 0 ? _a : "" },
                rankLow: rankLow[this.languageCode],
                rankHigh: rankHigh[this.languageCode],
                noBorder: this.noBorder,
                hidden: this.hidden,
            };
            if (required) {
                surveyConfigModule.validation = (0, util_1.addRequiredValidation)();
            }
            return surveyConfigModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    editProps() {
        var _a, _b, _c;
        return {
            id: this.id,
            type: this.type,
            rank: {
                low: (_a = this.rankLow[this.languageCode]) !== null && _a !== void 0 ? _a : "",
                high: (_b = this.rankHigh[this.languageCode]) !== null && _b !== void 0 ? _b : "",
                range: this.rankRange,
            },
            question: (_c = this.label[this.languageCode]) !== null && _c !== void 0 ? _c : "",
            actionRequired: this.actionRequired,
            hidden: this.hidden,
        };
    }
}
exports.RankedQuestionModule = RankedQuestionModule;
//# sourceMappingURL=RankedQuestion.js.map